"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Overlay = _styledComponents.default.div(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"])), function (_a) {
  var overlay = _a.overlay;
  return overlay ? 'rgba(0, 0, 0, 0.6)' : 'transparent';
});

exports.Overlay = Overlay;
var templateObject_1;